import { Fragment } from "react";
import { useSelector } from "react-redux";
import { DoubleStar } from '../../constants/ImagePaths';
import Image from '../../components/general/Image';
import DashedChips from '../../components/common/DashedChips';

const ExperienceHighlights = () => {
    const { developer: { detail } } = useSelector(state => state.common);
    if (!Boolean(detail?.experiences?.length)) return null;
    return (
        <Fragment>
            <h3 className="text-[30px] font-bold flex justify-start mb-[20px]">
                <span>Recent Experience Highlights</span>
                <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block translate-y-[-10px]" />
            </h3>
            <div className="flex flex-col gap-[20px]">
                {
                    detail.experiences.map((exp, index) => {
                        return <Experience
                            key={index}
                            title={exp.designation}
                            date={`${exp.start_month_year} - ${exp.end_month_year}`}
                            duration={exp.experience_in_years_and_month}
                            description={exp.project_overview}
                            skills={[...(exp?.skills_used || [])]}
                            responsibilities={exp.responsibilities}
                        />
                    })
                }
            </div>
        </Fragment>
    );
};
const Experience = ({ title, date, duration, description, skills, responsibilities }) => (
    <div>
        <div className="md:flex md:justify-between items-start">
            <div className="flex items-center gap-[10px] justify-start">
                <div className="hidden lg:block h-[10px] w-[10px] bg-primary-color rounded-full"/>
                <h3 className="text-primary-color ">{title}</h3>
            </div>
            <div className="bg-[#292929] text-[#A0A0A0] text-[13px] px-[10px] py-[5px] rounded-[6px] w-[60%] md:w-[35%] lg:w-[240px] mt-[10px] md:mt-[0px]">
                <p>{date}</p>
                <p>{duration}</p>
            </div>
        </div>

        <div className="lg:border-l lg:border-dashed lg:border-gray-500 lg:ml-[5px] lg:pl-[20px] lg:mb-[30px]">
            <div className="text-[14px] font-bold mt-[30px] lg:mt-[0px] lg:text-[17px] lg:mb-[10px]">Project Overview</div>

            <p className="font-extralight text-[14px] lg:text-[14px] unreset" dangerouslySetInnerHTML={{ __html: description }} />

            <div className="text-[14px] font-bold mt-[30px] lg:text-[17px] lg:mb-[10px]">Responsibilities</div>

            <div className="list">
                <p className="font-extralight text-[14px] lg:text-[14px] unreset" dangerouslySetInnerHTML={{ __html: responsibilities }} />
            </div>

            {
                Boolean(skills?.length) && (
                    <Fragment>
                        <div className="text-[14px] font-bold mt-[30px] lg:mb-[10px]">Skills Used & Tech Stack</div>

                        <div className="grid grid-cols-2 md:grid-cols-4 lg:flex lg:flex-wrap gap-[10px] mt-[10px]">
                            {
                                skills.map((skill, index) => (
                                    <DashedChips keyName={index} text={skill} />
                                ))
                            }
                        </div>
                    </Fragment>
                )
            }
        </div>
    </div>
);
export default ExperienceHighlights;